import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Spinner } from "@/components/shared";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading || user === null) {
    return <div className="flex min-h-screen items-center justify-center"><Spinner /></div>;
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}

export function GlobalAdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return <div className="flex min-h-screen items-center justify-center"><Spinner /></div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!user.global_admin) return <Navigate to="/app/dashboard" replace />;
  return children;
}
